import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=4cab1360&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=4cab1360&prod&lang=scss&scoped=true"
import style1 from "./TaskItem.vue?vue&type=style&index=1&id=4cab1360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab1360",
  null
  
)

export default component.exports